// 交易看板标题组件
export default {
  // 标题
  tradingDashboard: "交易看板",
  updated: "更新",

  // 提示信息
  delayTooltip:
    "地址首次加入交易看板时，数据最多会有1个小时的延迟，请耐心等待。",

  // 占位符和标签
  selectCurrency: "选择币种",
  allBlockchains: "全部",
};
